export default {
      id: "default-usage",
      viewBox: "0 0 11.502 8.002",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#default",
      toString: function () {
        return this.url;
      }
    }